// extracted by mini-css-extract-plugin
export default {"arrow_block":"styles_arrow_block__kSmbj","open_icon":"styles_open_icon__JXgf6","open_icon_rotate":"styles_open_icon_rotate__wnMwW"};